<style>
.gradient-background {
  background: #00d301;
  background: -webkit-linear-gradient(11deg,#00d301,#36c275 50%,#00a562);
  background: linear-gradient(79deg,#00d301,#36c275 50%,#00a562);
}
.gradient-text {
  background: #00d301;
  background: -webkit-linear-gradient(11deg,#00d301,#36c275 50%,#00a562);
  background: linear-gradient(79deg,#00d301,#36c275 50%,#00a562);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  text-fill-color: transparent;
  /* -webkit-text-fill-color: transparent; */
}
</style>
<template>
<v-container grid-list-md text-xs-center ma-0 pa-0 style="border: 0px">
  <v-layout ma-0 pa-0 style="border: 0px">
  <v-flex xs4>
    <v-card class="gradient-background ">
        <div class="text-xs-center gradient-texts" style="padding: 20px 0 0 0; color: #fff">
          <!--<v-icon color="white">visibility</v-icon>-->
          <div>{{ name }}</div>
          <p class="display-2 font-weight-medium">
            {{ sum }}
          </p>
        </div>
        <div>
          <apexchart height="60" :type="options.chart.type" :options="options" :series="options.series" />
        </div>
    </v-card>
  </v-flex>
  </v-layout>
</v-container>
</template>
<script>

var randomizeArray = function (arg) {
  var array = arg.slice();
  var currentIndex = array.length,
    temporaryValue, randomIndex;

  while (0 !== currentIndex) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

// data for the sparklines that appear below header area
var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43, 19, 46];


export default {
    props:['chart'],
    data: function() {
      return {
        sum: '110.50M',
        name: 'Total Visits',
        options: {
          colors: ['#fff'],
      chart: {
        type: 'area',
        height: 30,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: 'straight'
      },
      fill: {
        opacity: 0.9
      },
      series: [{
        data: randomizeArray(sparklineData)
      }],
      xaxis: {
        crosshairs: {
          width: 1
        },
      },
      yaxis: {
        min: 0
      },
      // title: {
      //   text: '$135,965',
      //   offsetX: 0,
      //   style: {
      //     fontSize: '30px',
      //     cssClass: 'apexcharts-yaxis-title display-3 font-weight-medium"'
      //   }
      // },
      // subtitle: {
      //   text: 'Profits',
      //   offsetX: 0,
      //   style: {
      //     fontSize: '14px',
      //     cssClass: 'apexcharts-yaxis-title'
      //   }
      // }
    }
      };
    },
    methods: {

    },
    computed: {

    },
    components: {

    },
    mounted: function() {
      console.log(this);
    }
}

</script>
